import Icons from 'src/app/core/enums/icons.enum';
import { Application } from '../../../portaljs/constants/application';

export class PortalApp {
  public app: Application;
  public isExternal: boolean = false;
  public icon: Icons;
  public url: string;
  public accessible: boolean = true;
  private readyResponseReceived: boolean = false; // Only set to true when an actual 'ready' message is received.
  public internal: boolean = false; // Currently used to hide 'fake' Collections (for User Profile) window when user does not have access to Collections
  public parent: Application;
  public children?: Application[] = [];
  public loadingError: boolean = false;
  public isOverlay: boolean = false; // Currently, only Juniper Sidecar

  constructor(app: Application, url: string, isExternal: boolean = false, icon: Icons, psariEnabled: boolean = false, destinyUiEnabled: boolean = false) {
    this.app = app;
    this.url = url;
    this.isExternal = isExternal;
    this.icon = icon;
    this.accessible = true;
    this.readyResponseReceived = false;

    if (app === Application.DESTINY) {
      if (psariEnabled) {
        this.children.push(Application.PSARI);
      }
      if (destinyUiEnabled) {
        this.children.push(Application.DESTINY_UI);
      }
    } else if (app === Application.PSARI || app === Application.DESTINY_UI) {
      this.parent = Application.DESTINY;
    }
  }

  public setReadyResponseReceived(responseReceived: boolean): void {
    this.readyResponseReceived = responseReceived;
  }
  public isReadyResponseReceived(): boolean {
    return this.readyResponseReceived;
  }
}
